import React, { FC, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { CurrentUserContext } from './CurrentUserContext';
import { apiUser } from '../resources/api/apiUser';
import { IUserInfo } from '../resources/models/IUserInfo';
import { AuthContext } from './AuthContext';
import { useApiErrorHandler } from '../hooks/useApiErrorHandler';

const { useGetCurrent } = apiUser;

export const CurrentUserContextProvider: FC = ({ children }) => {
  const { identity } = useContext(AuthContext);

  const [userInfo, setUserInfo] = useState<IUserInfo | null>(null);

  const currentUserResource = useGetCurrent();
  const handleError = useApiErrorHandler();

  const refetchUserInfo = useCallback(async () => {
    try {
      setUserInfo(null);
      const response = await currentUserResource.execute();
      setUserInfo(response.payload);
    } catch (e) {
      handleError(e);
      setUserInfo(null);
    }
  }, [currentUserResource]);

  useEffect(() => {
    if (identity) {
      refetchUserInfo().then();
    } else {
      setUserInfo(null);
    }
  }, [refetchUserInfo, identity?.userId]);

  const contextVal = useMemo(
    () => ({
      userInfo: userInfo?.id === identity?.userId ? userInfo : null,
      refetchUserInfo,
    }),
    [userInfo, refetchUserInfo, identity?.userId]
  );

  return <CurrentUserContext.Provider value={contextVal}>{children}</CurrentUserContext.Provider>;
};
